
import { trigger, transition, style, query, group, animate, AnimationMetadata } from '@angular/animations';

const baseStyles: Record<string, string | number> = {
  position: 'absolute',
  top: 0, 
  left: 0, 
  width: '100%',
  height: '100%'
};

const slideLeft: AnimationMetadata[] = [
  style({ position: 'relative' }),
  query(':enter, :leave', [
    style(baseStyles)
  ], { optional: true }),
  query(':enter', [
    style({ left: '100%' })
  ], { optional: true }),
  query(':leave', [
    style({ left: '0%' })
  ], { optional: true }),
  group([
    query(':leave', [
      animate('400ms ease-in-out', style({ left: '-100%' }))
    ], { optional: true }),
    query(':enter', [
      animate('400ms ease-in-out', style({ left: '0%' }))
    ], { optional: true })
  ]),
];

const slideRight: AnimationMetadata[] = [
  style({ position: 'relative' }),
  query(':enter, :leave', [
    style(baseStyles)
  ], { optional: true }),
  query(':enter', [
    style({ left: '-100%' })
  ], { optional: true }),
  query(':leave', [
    style({ left: '0%' })
  ], { optional: true }),
  group([
    query(':leave', [
      animate('400ms ease-in-out', style({ left: '100%' }))
    ], { optional: true }),
    query(':enter', [
      animate('400ms ease-in-out', style({ left: '0%' }))
    ], { optional: true })
  ]),
];

export const routeAnimations = trigger('routeAnimations', [
  transition((fromState, toState) => fromState > toState, slideRight), // BACKWARD
  transition((fromState, toState) => fromState < toState, slideLeft),  // FORWARD
]);
